import { render, staticRenderFns } from "./OurValidationDialog.vue?vue&type=template&id=423d5de9&"
import script from "./OurValidationDialog.vue?vue&type=script&lang=js&"
export * from "./OurValidationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports